import { AsyncPipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { AngularFireAnalytics } from "@angular/fire/compat/analytics";
import { Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { IonicModule, NavController } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { BehaviorSubject, firstValueFrom } from "rxjs";
import { CommonVariable } from "src/app/app.constants";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { PaymentDataService } from "src/app/services/payment-data.service";
import { UserManagementService } from "src/app/services/user-management.service";

@Component({
  selector: "app-fork1",
  templateUrl: "./fork1.page.html",
  styleUrls: ["./fork1.page.scss"],
  standalone: true,
  imports: [
    IonicModule,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class Fork1Page implements OnInit {
  hints = ["Choose your favourite lotteries", "Play to maximise your chances", "Get rewarded for being a member"];
  data$ = new BehaviorSubject<boolean>(false);
  selectedLanguage: string = CommonVariable.preferredLanguage;
  public languageCode = "en";
  public preferredCurrency;
  public currencySymbol;
  public currency;
  public forkPrize;
  public userId: string;
  constructor(
    private router: Router,
    private navCtrl: NavController,
    private analytics: AngularFireAnalytics,
    public translate: TranslateService,
    private authService: AuthService,
    private GTMSegment: GTMSegmentService,
    private userManagementService: UserManagementService,
    private paymentDataService: PaymentDataService
  ) {
    this.GTMSegment.GTMPopupInitialization("CreateSyndicate");
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        if (l) {
          translate.use(l ? l : "en");
        }
      },
      (err) => {
        return err;
      }
    );
    this.initializeData();
  }

  private async initializeData() {
    try {
      this.preferredCurrency = this.userManagementService.getSelectedCurrency();
      // Fetch currency symbol
      const currencyListResponse = await firstValueFrom(this.authService.getCurrencyList$) as Data;
      const CurrencyDetails = currencyListResponse?.details?.find(
        (x: any) => x.currency_code === this.preferredCurrency
      );
      if (CurrencyDetails?.currency_symbol) {
        this.currencySymbol = CurrencyDetails?.currency_symbol;
      } else {
        this.currencySymbol = CurrencyDetails?.currency_symbol || "£";

      }
      // Fetch currency value
      const paymentResponse = await firstValueFrom(this.paymentDataService.getPaymentPageData('3157'));
      if (paymentResponse && paymentResponse.int_fork_prize) {
        this.forkPrize = paymentResponse.int_fork_prize[this.preferredCurrency];
      }

      if (paymentResponse && paymentResponse.int_price) {
        this.currency = paymentResponse.int_price[this.preferredCurrency];
      }

      // Trigger data load flag
      if (this.currency && this.currencySymbol) {
        setTimeout(() => {
          this.data$.next(true);
        }, 1000);
      }

    } catch (err) {
      throw new Error(`Failed to fetch data: ${err}`);
    }
  }


  async ngOnInit() {
    await this.authService
      ?.getUid("Fork1Page")
      ?.then((uid) => {
        this.userId = uid;
      })
      .catch((error) => {
        return error;
      });
    this.analytics.logEvent("Fork1_page", { userId: this.userId });
    const keys = [
      "fork1.Choose",
      "fork1.Playto",
      "fork1.member",
      "fork1.win_big",
      "fork1.Smart-way",
      "fork1.Decide later",
      "fork1.more_chances",
      "fork1.Or",
      "fork1.Play",
      "fork1.Create",
      "syndicate-tickets.For",
      "syndicate-tickets.line(s)"
    ];

    this.translate.get(keys).subscribe(
      (res: { [key: string]: string }) => {
        this.hints = keys.map(key => res[key]);
        setTimeout(() => {
          this.data$.next(true);
        }, 2000);
      },
      (err) => {
        return err;
      }
    );
  }

  createSyndicate() {
    this.navCtrl.navigateForward("/syndicate/fork2");
  }
  backToTabs() {
    this.router.navigateByUrl("/mainTabs/tabs/home");
  }
  goToStore() {
    this.router.navigateByUrl("/mainTabs/tabs/store");
  }
  goToFreeReg4c() {
    this.router.navigateByUrl("/free-reg-step4c?prosub_id=3157");
  }
}
